export function buildSlots(prepMinutes = 20) {
  const now = new Date();
  const day = now.getDay();
  const closeHour = day === 5 || day === 6 ? 27 : 25;
  const end = new Date(now);
  end.setHours(closeHour, 0, 0, 0);
  let t = new Date(now.getTime() + prepMinutes * 60000);
  t.setSeconds(0, 0);
  t.setMinutes(Math.ceil(t.getMinutes() / 15) * 15);
  const open = new Date(now);
  open.setHours(10, 0, 0, 0);
  if (t < open) t = open;
  const out = [];
  while (t <= end && out.length < 70) {
    out.push(`${String(t.getHours()).padStart(2, "0")}:${String(t.getMinutes()).padStart(2, "0")}`);
    t = new Date(t.getTime() + 15 * 60000);
  }
  return out;
}

export function fmtSlot(s) {
  const [h, m] = s.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${ampm}`;
}
